/**
 * @file FeatureExperiments.tsx
 * @description This file contains the FeatureExperiments component,
 * which is the main page component for the Feature Experiments page.
 */

import { Page } from "../Components";
import { RouteComponentProps, Router } from "@reach/router";
import { useTabbedNav } from "../utils/hooks/useNav";
import ExperimentFlags from "./ExperimentFlags";
import UserExperiments from "./UserExperiments";
import CompanyExperiments from "./CompanyExperiments";
import UserGroups from "./UserGroups";
import React from "react";

const enum PageTab {
  USER_EXPERIMENTS = "user-experiments",
  COMPANY_EXPERIMENTS = "company-experiments",
  USER_GROUPS = "user-groups",
  EXPERIMENT_FLAGS = "experiment-flags",
}

const NAVS = [
  { label: "User Experiments", key: PageTab.USER_EXPERIMENTS },
  { label: "Company Experiments", key: PageTab.COMPANY_EXPERIMENTS },
  { label: "User Groups", key: PageTab.USER_GROUPS },
  { label: "Experiment Flags", key: PageTab.EXPERIMENT_FLAGS },
];
export default React.memo(({ navigate }: RouteComponentProps) => {
  const { tab, goToTab } = useTabbedNav({
    navigate,
    baseURL: "feature-experiments",
    defaultKey: PageTab.USER_EXPERIMENTS,
    navs: NAVS.map(nav => nav.key, NAVS),
  });

  return (
    <Page
      app2Redesign
      navs={NAVS}
      onNav={goToTab}
      pageType="Feature Experiments"
      selectedNav={tab}
      title="Feature Experiments"
    >
      <div className="featureExperimentsPage">
        <Router className="fullPageRouter">
          <UserExperiments path={PageTab.USER_EXPERIMENTS} />
          <CompanyExperiments path={PageTab.COMPANY_EXPERIMENTS} />
          <UserGroups path={PageTab.USER_GROUPS} />
          <ExperimentFlags path={PageTab.EXPERIMENT_FLAGS} />
        </Router>
      </div>
    </Page>
  );
});
